enum LisioPopinNames {
  POPIN2024 = "popin2024",
  POPIN2024HELP = "popin2024help",
  POPIN2024_ACCESSMOBILE_CLOSE = "popin2024_accessmobile_close",
  POPIN2025 = "popin2025",
}

export default LisioPopinNames;
